<div class="favorites-list-box">
  @if (dataSource) {
    <abc-list
      [dataSource]="dataSource"
      [grouped]="true"
      [collapsibleGroups]="true"
      [hoverStateEnabled]="false"
      [searchEnabled]="true"
      [searchMode]="sreachModeList"
      [selectionMode]="selectionModeList"
      (onContentReady)="contentReady()"
      (onItemClick)="itemClicked($event)"
      noDataText="{{ dataService.res('Favorites-No-Data') }}"
      >
      <dxo-search-editor-options placeholder="{{ dataService.res('Favorites-Search') }}"> </dxo-search-editor-options>
      <div *dxTemplate="let item of 'item'">
        <div matTooltip="{{ item['DisplayText'] }}">{{ item['DisplayText'] || '' }}</div>
      </div>
    </abc-list>
  }

  <div class="loader-container"></div>
</div>
